import React, { useState } from "react";

import Input from "../../controls/Input";
import SelectMenu from "../../controls/SelectMenu";

import {
  classNames,
  convertToDefEventPara,
  formatDateWithTime,
  generateUniqueNumber,
  wipStatusOptions,
} from "../../../shared/utility";
import ButtonSpinner from "../../controls/ButtonSpinner";
import WipsNotesModal from "./WipsNotesModal";
import TraceableLotNumber from "../../controls/TraceableLotNumber";
import ReadonlyIdentifierField from "../../controls/ReadonlyIdentifierField";

export default function WipFields(props) {
  const {
    isEdit,
    handleInputChange,
    values,
    errors,
    handleSubmit,
    submitInProgress,
    roomOptions,
    onAddItemToWipByBarcode,
    setEmptyModelOpen,
  } = props;

  const [barcodeScanInProgress, setBarcodeScanInProgress] = useState(false);

  const handleBarcodeScan = async function (scannedBarcode) {
    if (scannedBarcode || scannedBarcode !== "") {
      setBarcodeScanInProgress(true);

      const result = await onAddItemToWipByBarcode(scannedBarcode);
      handleInputChange(convertToDefEventPara("scanned_barcode", ""));
      setBarcodeScanInProgress(false);
    }
  };

  return (
    <div className="pt-6 pb-5 grid grid-cols-1 gap-2">
      <div className="p-4 card-custom space-y-5">
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">
          <SelectMenu
            handleInputChange={handleInputChange}
            name="room_selected"
            options={roomOptions}
            value={values.room_selected}
            title={"Room"}
            disabled={isEdit}
            error={errors.room_selected}
          />
          {isEdit ? (
            <ReadonlyIdentifierField label="Lot number">
              <TraceableLotNumber
                lotNumber={values.lot_number}
                traceType="manufactured"
              />
            </ReadonlyIdentifierField>
          ) : (
          <div>
            <Input
              label="Lot number"
              name="lot_number"
              onChange={handleInputChange}
              value={values.lot_number}
              labelOn={true}
              type="text"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
              error={errors.lot_number}
            />
            <button
              type="button"
              className="mt-1 text-sm text-purple-600 font-bold"
              onClick={() => {
                const generatedLotNumber = generateUniqueNumber();
                handleInputChange(
                  convertToDefEventPara("lot_number", generatedLotNumber)
                );
              }}
            >
              Generate
            </button>
          </div>
          )}
          <Input
            label="Date created"
            name="created_date"
            onChange={handleInputChange}
            value={formatDateWithTime(values.created_date)}
            labelOn={true}
            type="text"
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            error={errors.created_date}
            disabled={true}
          />
          <SelectMenu
            handleInputChange={handleInputChange}
            name="status_selected"
            options={wipStatusOptions}
            value={values.status_selected}
            title={"Status"}
            parentClass={classNames(isEdit ? null : "hidden")}
            error={errors.status_selected}
          />
        </div>
        {isEdit ? (
          <div className="grid grid-cols-1 gap-4 mb-3 sm:grid-cols-2 xl:grid-cols-4">
            <div
              id="barcode-scan-text-input-parent"
              className="sm:col-span-2 xl:col-span-2"
            >
              <input
                placeholder="Scan barcode to add incoming item"
                name="scanned_barcode"
                disabled={barcodeScanInProgress}
                onChange={handleInputChange}
                value={values.scanned_barcode}
                onKeyDown={(e) => {
                  if (e.key === "Enter") handleBarcodeScan(e.target.value);
                }}
                type="text"
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
              />
            </div>

            <Input
              label="Date closed"
              name="closed_date"
              onChange={handleInputChange}
              value={formatDateWithTime(values.closed_date)}
              labelOn={true}
              type="text"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
              disabled={true}
            />
            <Input
              label="Closed by"
              name="closed_by"
              onChange={handleInputChange}
              value={values.closed_by_name}
              labelOn={true}
              type="text"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
              disabled={true}
            />
          </div>
        ) : null}
        <button
          type="submit"
          className={classNames(
            isEdit
              ? "hidden"
              : "inline-flex w-full sm:w-auto justify-center rounded-md bg-main-purple px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          )}
          onClick={handleSubmit}
        >
          <ButtonSpinner spin={submitInProgress} text="Create" />
        </button>
      </div>
      <div className="card-custom p-3 mt-1 w-full md:w-1/4 md:ml-auto">
        <div className="flex justify-between">
          <p className="text-sm text-gray-700 font-semibold">Notes</p>
          <button
            onClick={() =>
              setEmptyModelOpen({
                childComponent: (
                  <WipsNotesModal
                    orderNote={values.notes}
                    confirmAction={(newNote) =>
                      handleInputChange(convertToDefEventPara("notes", newNote))
                    }
                    setOpen={setEmptyModelOpen}
                  />
                ),
                open: true,
              })
            }
            className="text-sm font-semibold main-purple"
          >
            Edit
          </button>
        </div>
        <p className="text-sm text-gray-700 font-normal">
          {values.notes ? values.notes : "No notes"}
        </p>
      </div>
    </div>
  );
}
